var app = angular.module('cmsWeb', [

    'ui.router',
    'cmsWeb.main',
    'global.webServices.factory',
    'eStories.registration.model',
    'global.filters',

]).config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('cmsWeb', {
            url: '',
            abstract: true
        });

    // $locationProvider.html5Mode({enabled: true, requireBase: false});


    // $urlRouterProvider.otherwise(function($injector, $location) {
    //         var path = $location.path();
    //         var normalized = path.toLowerCase();
    //
    //         if (normalized.localeCompare("")) {
    //             $location.path('/');
    //         }
    //     });

})


    .run(['$rootScope',
        '$state',
        '$timeout',
        'CmsAccountModel',
        function ($rootScope, $state, $timeout, CmsAccountModel) {

            $rootScope.$on('$viewContentLoaded', function (event) {
                $rootScope.currentState = $state.current.name;


            });

            /*checkForSession*/
            CmsAccountModel.refreshCmsAccountDetails.then(response => {
                if (response && response.responseStatus === 'SUCCESS' &&
                    CmsAccountModel.hasAccess($rootScope.roles.CMS_READ_ONLY)) {
                    $timeout(function () {
                        $rootScope.$broadcast('successfulSignIn');
                    }, 200);
                }
            });
        }]);